module.exports = __webpack_public_path__ + "img/empty logo.761adbb6.png";